import { useState } from 'react';
import { useSelector } from 'react-redux';
import {
  IUnitAreaAsset,
  IUnitAreaAssetsResponse,
} from 'src/services/api/UnitAreaAssets/apiContracts';
import {
  getAssetsBySuiteId,
  getAuthenticatedUser,
  isApiError,
} from 'src/services/client';
import { selectAuthenticatedUser } from 'src/store/selectors/auth';

export const useUnitAreaAssets = () => {
  const user = useSelector(selectAuthenticatedUser);
  const [unitAreaAssets, setUnitAreaAssets] = useState<IUnitAreaAsset[]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  const fetchData = async (suiteId) => {
    setLoading(true);
    try {
      const response = await getAssetsBySuiteId(
        suiteId,
        user?.id,
        user?.roles[0]?.role?.name
      );
      if (!response || isApiError(response)) {
        console.error('Failed to fetch unit area assets:', response);
        return;
      }
      const { data }: IUnitAreaAssetsResponse = await response.json();
      setUnitAreaAssets(data || []);
    } catch (error) {
      console.error('Error fetching unit area assets:', error);
    } finally {
      setLoading(false);
    }
  };

  return {
    unitAreaAssets,
    fetchData,
    loading,
  };
};
